import React, { useState, useEffect } from "react";
import { patchAPI, getAPI } from "../../../services/basehttpAPI";
import {
  Container,
  Stack,
  Typography,
  Box,
  Paper,
  TextField,
  Grid,
  Button,
} from "@mui/material";
import MuiButton from "../../../components/muibutton";
import SnackbarComponent from "../../../components/snackbar";
import { useNavigate, useParams } from "react-router-dom";
const EditCustomShipToParty = () => {
  const params = useParams();
  const id = params.id;
  const [shipToPartyDetails, setShipToPartyDetails] = useState({});
  const [customShipToName, setCustomShipToName] = useState("");
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const navigate = useNavigate();
  const translatedText = JSON.parse(sessionStorage.getItem("TranslationText"));
  useEffect(() => {
    getShipToPartyDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const getShipToPartyDetails = async () => {
    let url = `ShipToParty/GetShipToPartyDetailById?customerShipToPartyId=${id}`;
    const response = await getAPI(url, null);
    setShipToPartyDetails(response?.responseData);
    setCustomShipToName(response?.responseData?.customShipToName || "");
  };
  const handleOnSubmit = (event) => {
    event.preventDefault();
    updateCustomShipToPartyName();
  }
  const handleCustomShipToNameChange = (event) => {
      setCustomShipToName(event.target.value || "");
  };
  const handleNavigation = () => {
    navigate(`/layout/viewcustomshiptoparty/${id}`);
  }
  const updateCustomShipToPartyName = async () => {
    let url = "ShipToParty/UpdateShipToParty";
    shipToPartyDetails.customShipToName = customShipToName;
    const response = await patchAPI(url, shipToPartyDetails);
    if (response.isSuccess) {
      setOpen(true);
      setSeverity("success");
      setMessage(translatedText?.custom_ship_to_name_update_success);
      setShipToPartyDetails(response?.responseData);
      navigate(`/layout/viewcustomshiptoparty/${id}`, { state: { isEditCustomShipToPartyRedirect: true } });
    }
    else {
      setMessage(response?.errorMessages);
      setOpen(true);
      setSeverity("error");
    }
  };
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <Container maxWidth="lg" sx={{ mb: "50px" }}>
      <Typography variant="h5" flexGrow={1}>
        {translatedText?.edit_custom_ship_to_party_name}
      </Typography>
      <Paper sx={{ width: "100%", height: "100%", mt: "20px" }}>
        <Box
          component="form"
          sx={{
            "& .MuiFormControl-root": {
              width: "90%",
            },
          }}
          noValidate
          autoComplete="off"
          onSubmit={handleOnSubmit}
        >
          <Grid container sx={{ alignItems: "center", pl: "10px" }}>
            <Grid item xs={12} sm={6} md={6} sx={{ pl: "10px" }}>
              <span className="fontcolor label-txt">
                {shipToPartyDetails?.shipToName}
              </span>
              <div className="fontheadercolor label-txt">{translatedText?.ship_to_name}</div>
            </Grid>
            <Grid item xs={12} sm={6} md={6} sx={{ pl: "10px" }}>
              <TextField
                margin="normal"
                id="customShipToName"
                label={translatedText?.edit_custom_ship_to_party_name}//"Indas Customer ID"
                name="customShipToName"
                autoComplete="off"
                value={customShipToName || ""}
                onChange={handleCustomShipToNameChange}
              />
            </Grid>
            <Grid item xs={12}>
              <Stack
                direction="row"
                spacing={2}
                style={{ display: "flex", justifyContent: "flex-end" }}
                marginRight={"30px"}
                marginTop={"10px"}
              >
                <MuiButton
                  text={translatedText.cancel}//"Cancel"
                  color="grey"
                  onClick={handleNavigation}
                  show={true}
                />
                <Button
                  type="submit"
                  variant="contained"
                  color="success"
                  sx={{ mt: 3, mb: 2 }}
                >
                  {" "}
                  {translatedText.save}
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </Paper>
      <SnackbarComponent
        open={open}
        handleClose={handleClose}
        message={message}
        severity={severity}
      />
    </Container>
  );
}
export default EditCustomShipToParty;